import { render } from "./PageItemForm.vue?vue&type=template&id=e4c5eca8&scoped=true"
import script from "./PageItemForm.vue?vue&type=script&lang=js"
export * from "./PageItemForm.vue?vue&type=script&lang=js"

import "./PageItemForm.vue?vue&type=style&index=0&id=e4c5eca8&scoped=true&lang=scss"

import exportComponent from "/home/itube/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4c5eca8"]])

export default __exports__